module.exports = __webpack_public_path__ + "img/图片6.f68fab27.png";